import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { Heading1, Heading2, Section, Centered, withColor, SecondaryButton, PrimaryButton, Text, Link, Heading4, Heading3 } from './MarketingStyles';
import { withRouter } from 'react-router-dom'
import config from 'react-global-configuration';
import checkmark from '../../images/icons/checkmark.svg'
import { trackEvent } from "../../utils/eventTracking"

import { inject, observer } from 'mobx-react'

@inject('utilStore', 'translationStore')
@observer
class PricingSection extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    const { membershipTypes } = this.props.utilStore

    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <Section id="pricing">
        <Heading1 style={{width: '100%', textAlign: 'center'}}>{ text('marketing_price_headline') }</Heading1>
        <PricingTable>
        {
          membershipTypes && membershipTypes.map(item => {

            const Button = item.highlighted ? PrimaryButton : SecondaryButton
            const clickHandler = item.button_link ? e => { e.preventDefault(); window.open(item.button_link.replace("[at]", "@"), "_blank") } : () => this.props.history.push("/bewerbung")

            const price = item.discounted_price || item.price

            console.log(item);
            console.log(item.discounted_price);
            console.log(item.price);

            return (
              <PricingItem key={item.name} highlighted={ item.highlighted }>
                <Centered>
                  <PricingTitle className="title">{ item.name }</PricingTitle>
                  { item.discounted_price && <OldPrice> { item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") } €</OldPrice>}
                  <Price price={ price }>{ price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }{item.special ? '' : '€' }</Price>
                  { !item.special && <UstText>exkl. USt</UstText> }
                  { item.discounted_price && <DiscountNotice> { item.discountNotice } </DiscountNotice>}
                  <PricingHint>{ item.text }</PricingHint>
                </Centered>

                <FeatureList>
                  { item.features && item.features.map(item => (
                    <FeatureItem>
                      <img src={ checkmark } />
                      <span dangerouslySetInnerHTML={{ __html: item.feature}}></span>
                    </FeatureItem>
                  )) }
                </FeatureList>
                <Button value={ item.button_text ? item.button_text : "Bewerben" } onClick={ (e) => { clickHandler(e); trackEvent( 'Apply - Prices - ' + item.name, 'Application', 'Button Click' ) } }/>
              </PricingItem>
          )})
        }
        </PricingTable>
      </Section>
    )
  }
}

export default withRouter(PricingSection)

const PricingTable = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  padding: 50px 0;

  ${cssVar.breakpoints.tablet} {
    padding-top: 0;
    display: flex;
    flex-direction: column;
  }
`


const PricingItem = styled.div `
  display: flex;
  background: ${ cssVar.colors.lightest_grey };
  ${'' /* height: ${ (props) => props.highlighted ? 'calc(100% + 100px)' : '100%' }; */}
  height: 100%;
  margin-top: 0;
  ${'' /* margin-top: ${ (props) => props.highlighted ? '-50px' : '0' }; */}
  width: 100%;
  flex-direction: column;
  padding: 50px;
  transition: all ${ cssVar.transitions.basic };

  ${cssVar.breakpoints.tablet} {
    margin-top: 0;
    padding: 30px;
    order: ${ (props) => props.highlighted ? '1' : '2' };
  }

  :hover {
    height: calc(100% + 100px);
    margin-top: -50px;
    filter: drop-shadow(0px 5px 20px rgba(47, 67, 97, 0.3));

    .title {

      background: ${ cssVar.colors.blue };
      color: white;
    }
  }
`

const PricingTitle = styled(Heading2) `
  text-transform: uppercase;
  margin: -50px -50px 0 -50px;
  padding: 50px;
  background: none;
  color: ${ cssVar.colors.blue };
  transition: all ${ cssVar.transitions.basic };

  ${cssVar.breakpoints.tablet} {
    margin: -30px -30px 0 -30px;
    padding: 30px;
  }
`

const Price = styled(Heading1) `
  padding: 20px 0 0 0;
  word-spacing: ${ (props) => props.price ? '-8px' : 'inherit' };
`

const OldPrice = styled(Heading2) `
  padding: 20px 0 0 0;
  margin-bottom: -10px;
  opacity: .7;
  text-decoration: line-through;
  word-spacing: ${ (props) => props.price ? '-8px' : 'inherit' };
`

const DiscountNotice = styled(Heading4) `
  padding: 10px 0 0 0;
  font-size: 14px;
  word-spacing: ${ (props) => props.price ? '-8px' : 'inherit' };
`

const FeatureList = styled.div `
  flex: 1;
  margin: 40px 0;

  ${cssVar.breakpoints.tablet} {
    text-align: center;
  }

  ${cssVar.breakpoints.phone} {
    text-align: left;
  }
`

const PricingHint = styled(Heading4) `
  padding-top: 20px;
  font-weight: bold;
`

const UstText = styled(Text) `
  margin-top: -10px;
  opacity: 0.75;
  font-family: 'Supreme-Medium';
`

const FeatureItem = styled.div `
  display: grid;
  grid-template-columns: 16px auto;
  grid-gap: 20px;
  margin: 10px;

  img {
    height: 16px;
    width: 16px;
    object-fit: contain;
  }

  ${cssVar.breakpoints.tablet} {
    display: block;

    img {
      margin-right: 16px;
      display: none;
    }
  }

  ${cssVar.breakpoints.phone} {
    display: grid;
    grid-template-columns: 16px auto;

    img {
      display: block;
    }
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/PricingSection.js